<template>
    <div>
      <router-view></router-view>
    </div>
  </template>
  
  <script>
  export default {
    name: "dispatchIndex",
    data() {
      return {}
    },
  };
  </script>